/**
 * This module exports globally accessible states of the universal block components.
 *
 * If the caller wants to use states of blocks for other purposes (e.g. it wants to use the tables' sort state
 * to sort its exports), it should import it from this module instead of directly importing it from where its
 * defined.
 *
 * If some global state doesn't exists here (e.g. regression state), we should add it here instead of importing
 * it directly.
 *
 * Callers should import the default export directly and call states as UniversalBlockGlobalClientStates.<state>
 * (e.g. UniversalBlockGlobalClientStates.sortState).
 */
import {runQueryOutputTableSortState} from 'insights/warehouse/useRunQueryOutputTableSortState';

import {showRawOutputState} from './components/RawOutputButton';

// All new export states should go in this default export.
export default {
  showRawOutputState,
  sortState: runQueryOutputTableSortState,
};
